import {
    faBell,
    faCalendar,
    faChartBar,
    faEnvelope,
    faFile,
    faFolder,
    faGear,
    faGlobe,
    faLink,
    faUser,
    type IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

export const ICON_MAP: Record<string, IconDefinition> = {
    globe: faGlobe,
    file: faFile,
    envelope: faEnvelope,
    "chart-bar": faChartBar,
    user: faUser,
    gear: faGear,
    link: faLink,
    bell: faBell,
    folder: faFolder,
    calendar: faCalendar,
};

export const FALLBACK_ICON = faGlobe;
